import { ethers } from "ethers";
import React, { Component } from "react";
import getContract from "../services/contract";
import withWrapper from '../helpers/withWrapper'
import getWallet, {disconnectWallet} from '../services/wallet';
import Header from './dashboard/header';

class Login extends Component {
  state = {
    id: '',
    userAddress: '',
    isConnected: false,
    lastId: 0,
    signer: null,
    totalValue: 0
  };

  handleDisconnect = async () => {
    disconnectWallet();
    this.setState({ signer: null });
  }

  connectWallet = async () => {
    const wallet = await getWallet();
    if(!wallet.isReadOnly) {
        const browserAddresses = await wallet.provider.listAccounts();
        this.setState({ signer: wallet.signer, userAddress: browserAddresses[0], isConnected: true });
      } else {
        alert('Wallet not connected')
    }
  }

  async componentDidMount() {
    await this.connectWallet();
    const contract = await getContract();
    const lastId = ethers.BigNumber.from(await contract.lastIDCount()).toNumber();
    let totalInvestedBN = await contract.totalValueInvested();
    let totalValue = ethers.BigNumber.from(
      totalInvestedBN.div(ethers.BigNumber.from("1000000"))
    ).toString();
    // const lastId = ethers.BigNumber.from().toNumber();
    this.setState({lastId, totalValue})
    console.log(this.state);
  }

  handleViewClick = async () => {
    const contract = await getContract();
    const id = this.state.id;
    const lastId = ethers.BigNumber.from(await contract.lastIDCount()).toNumber();
    if(lastId < id) {
      alert(`User Id ${id} not found`);
      return;
    }
    this.props.router.navigate('/dashboard/' + id);
  };

  handleLogin = async () => {
    const wallet = await getWallet();
    if(!wallet.isReadOnly) {
        const browserAddresses = await wallet.provider.listAccounts();
        const contract = await getContract();
        const id = ethers.BigNumber.from(await contract.getIdByAddress(browserAddresses[0])).toNumber();
        if(id == 0) {
          alert('No Id found with your connected wallet make sure switch to registered account on metamask');
          return;
        }
        this.props.router.navigate('/dashboard/' + id);
    }
  };

  render() {
    return (
        <div id="__next1">
          <div className="flex relative bg-main-bg flex-col items-center justify-center w-full min-h-screen text-white-500 px-10 sm:px-0 overflow-hidden pt-16">
          <Header
            isHome={true}
            onConnectWallet={this.connectWallet}
            userAddress={this.state.userAddress}
            signer={this.state.signer}
            onDisconnect={this.handleDisconnect}
          />
            <div className="flex flex-col flex-1 w-full max-w-desktop-login mt-7.5 sm:mt-0">
              <div className="flex flex-col">
                <div className="grid gap-10 mt-5 lg:grid-cols-1 lg:gap-5 z-10 sm:px-5">
                  <div className="w-full text-center">
                  </div>
                  {/* <div className="flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                    <div className="flex items-center">
                      <span className="text-white text-xl sm:whitespace-nowrap">
                        Total invested, USDT
                      </span>
                    </div>
                    <span className="text-white text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                      {this.state.totalValue}
                    </span>
                  </div> */}
                </div>
                <div className="flex flex-col mb-15 mt-15">
                  <div className="flex flex-col">
                    <div className="flex flex-col sm:px-5">
                      <span className="text-white text-3xl font-bold text-center">
                        View Account
                      </span>
                      <span className="text-white-500 text-base mt-1 mb-7.5 text-center">
                        Enter ID to preview and account details.
                      </span>
                    </div>
                    <div className="flex sm:flex-col">
                      <div style={{ color: 'black' }} className="flex flex-col flex-1 sm:w-full bg-black-light rounded sm:rounded-none p-7.5 sm:p-5 mr-10 sm:mr-0 sm:mb-5">
                        <span className="text-white mb-3">Enter ID</span>
                        <div className="flex sm:flex-col">
                          <input onChange={(e) => this.setState({id: e.target.value})}
                            value={this.state.id}
                            style={{background: 'white', color: 'black', fontSize: '24px'}}
                            className="w-full bg-white-100 border-2 border-transparent rounded-mini py-3 px-2 outline-none focus:border-2 focus:border-black flex-1 mr-5 sm:mr-0 sm:mb-3.5 py-2"
                            id="idbyPlan"
                            type="number"
                          />
                          <button style={{background: '#45BEA5', fontSize: '26px', color: "white"}}
                            onClick={this.handleViewClick}
                            className="flex justify-center items-center text-center text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-3 bg-blue-500 hover:bg-blue-700 active:bg-active-main-blue rounded-mini">
                            VIEW
                          </button>
                        </div>
                      </div>
                      <div className="w-1/3 min-w-320px sm:w-full sm:px-5">
                        <div className="flex flex-col w-full rounded bg-black-light p-7.5 relative">
                          <span style={{fontSize: '16px', fontWeight: 'bold'}} className="text-white text-center mb-3">
                            Log in to your account by wallet
                          </span>
                            <button style={{backgroundColor: "#45BEA5", fontSize: '26px'}} onClick={this.handleLogin} className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-3 bg-main-bg hover:bg-hover-main-bg active:bg-active-main-bg sm:w-full">
                              LOG IN
                            </button>

                          <img
                            src="img/favicon/apple-icon-120x120.png"
                            width="90"
                            className="sm:hidden absolute top-1/2 right-0 transform -translate-y-1/2"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
           
              </div>

            </div>
          </div>
        </div>
    );
  }
}

export default withWrapper(Login);